import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'discount-code',
  templateUrl: './discount-code.component.html',
  styleUrls: ['./discount-code.component.scss']
})
export class DiscountCodeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.currentDiscountCode.valueChanges.subscribe(() => {
      if (this.showDiscountCodeMessage) {
        this.showDiscountCodeMessage = false;
      }
    });
  }

  @Input() disableButtons: boolean;

  @Input() set appliedDiscountCode(appliedDiscountCode: string) {
    if (appliedDiscountCode != undefined) {
      this._appliedDiscountCode = appliedDiscountCode;
      if (this._appliedDiscountCode) {
        if (!this.currentDiscountCode.value) {
          this.currentDiscountCode.patchValue(this._appliedDiscountCode);
        }
        this.currentDiscountCode.disable();
      } else {
        this.currentDiscountCode.enable();
      }
      if (this.currentDiscountCode.value) {
        this.showDiscountCodeMessage = true;
      } else {
        this.showDiscountCodeMessage = false;
      }
    }
  };

  @Output() onCodeChange: EventEmitter<string> = new EventEmitter<string>();
  public currentDiscountCode = new FormControl();
  _appliedDiscountCode: string;
  showDiscountCodeMessage: boolean;

  applyDiscountCode() {
    if (this.currentDiscountCode.value) {
      this.onCodeChange.emit(this.currentDiscountCode.value);
    }
  }

  removeDiscountCode() {
    this.currentDiscountCode.patchValue('');
    this.onCodeChange.emit('');
  }

}
